import { Link } from "react-router-dom";
import { Card, CardBody, Col, Modal } from "reactstrap";
import { H5, Image } from "../../../../../AbstractElements";
import { CustomModalBodyType } from "../../../../../Types/UiKitsType";
import { dynamicImage } from "../../../../../Utils";
import SvgIcon from "../../../../CommonComponents/SvgIcon/SvgIcon";
import BalanceIconWrap from "./BalanceIconWrap";

const CustomModal3Body:React.FC<CustomModalBodyType> = ({ modal, toggle }) => {
  return (
    <Modal fade centered isOpen={modal} toggle={toggle}>
      <Col xl="12">
        <Card className="balance-box mb-0 rounded-0">
          <CardBody>
            <div className="balance-profile">
              <div className="balance-img">
                <Image src={dynamicImage(`product-lists/user.png`)} alt="user vector" />
                <Link to={`${process.env.PUBLIC_URL}/applications/users/user-profile`} className="edit-icon"><SvgIcon iconId="pencil" /></Link>
              </div>
              <span className="f-light d-block">{"Your Balance "}</span>
              <H5 className="mt-1 f-w-600">{"$768,987.90"}</H5>
              <BalanceIconWrap />
            </div>
          </CardBody>
        </Card>
      </Col>
    </Modal>
  );
};
export default CustomModal3Body;
